// removed by extract-text-webpack-plugin
module.exports = {"section508-container":"section508-container","alert-container":"alert-container","alert-content":"alert-content","required-fields-note":"required-fields-note","required-indicator":"required-indicator","section508-form":"section508-form","form-item":"form-item","required-field":"required-field","required-label":"required-label","error":"error","error-message":"error-message","submit-item":"submit-item","submit-button":"submit-button","submission-result":"submission-result","success":"success","section508-note":"section508-note"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/Section508/Section508.scss
// module id = 4399
// module chunks = 1